import { ACTION_CONSTANTS } from 'constants';
import EventEmitter from 'wolfy87-eventemitter';
import debug from 'lib/common/debug';

function checkAction(action) {
    if (typeof action === 'undefined') {
        throw new Error('No action provided');
    }
    if (ACTION_CONSTANTS[action] === undefined) {
        throw new Error(`Action (${action}) has not been defined`);
    }
}

let ee = new EventEmitter();

ee.defineEvents(Object.keys(ACTION_CONSTANTS)
    .map(key => ACTION_CONSTANTS[key]));

export const ACTIONS = ACTION_CONSTANTS

export default {
    ee: ee,
    ACTIONS: ACTION_CONSTANTS,
    publish: function(action, data) {
        checkAction(action);
        debug.info(`[SYOS] ${action}`, data);
        ee.emit(action, data);
    },
    subscribe: function(action, fn) {
        checkAction(action);
        ee.on(action, fn);
    },
    unsubscribe: function(action, fn) {
        checkAction(action);
        ee.off(action, fn);
    }
}



// WEBPACK FOOTER //
// ./src/javascripts/app/mediator.js